module.exports = __webpack_public_path__ + "img/DAY4-2.21e5a590.jpg";